import canSendJob from './canSendJob';
import canSendMessage from './canSendMessage';
import canAccessCv from './canAccessCv';
import canExportProfile from './canExportProfile';
import getCvPreviewStatus from './getCvPreviewStatus';
import isApproachable from './isApproachable';
import showLocationFoundInCv from './showLocationFoundInCv';
import getSimilarCandidatesDataFromProfile from './getSimilarCandidatesDataFromProfile';
import hasRoleFoundInCV from './hasRoleFoundInCV';
import hasLocationFoundInCvOnSummary from './hasLocationFoundInCvOnSummary';
import getLastInteractionTimestamp from './getLastInteractionTimestamp';

export default {
  canSendJob,
  canSendMessage,
  canAccessCv,
  canExportProfile,
  getCvPreviewStatus,
  isApproachable,
  showLocationFoundInCv,
  getSimilarCandidatesDataFromProfile,
  getLastInteractionTimestamp,
  hasRoleFoundInCV,
  hasLocationFoundInCvOnSummary,
};
